import ScoreTrendChart from './ScoreTrendChart';

export default ScoreTrendChart;

export type { IScoreTrendChartProps, ScoreTrendHue } from './ScoreTrendChart';
